<ng-container *ngIf="question">
  <div class="grid-table-container">
    <table class="grid-table">
      <thead>
        <tr>
          <th></th>
          <th *ngFor="let col of serializedFieldTypeSpecs.colNames">
            <div class="mb-3 fw-normal fs-16 mx-3 text-center">{{ col }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of serializedFieldTypeSpecs.rowNames">
          <td>
            <div class="my-2 me-3">{{ row }}</div>
          </td>
          <td *ngFor="let col of serializedFieldTypeSpecs.colNames">
            <div class="grid-cell-content">
              <input
                [id]="'option-' + question.id + '-' + row + '-' + col"
                type="checkbox"
                [checked]="isCellChecked(row, col)"
                [name]="'checkbox-' + question.id"
                class="form-check-input grid-cell-checkbox"
                [ngStyle]="{
                  pointerEvents: isInputInteractive ? 'auto' : 'none',
                  opacity: 1,
                  cursor: isInputInteractive ? 'pointer' : 'default'
                }"
                [attr.tabindex]="isInputInteractive ? 0 : -1"
                (change)="
                  isInputInteractive && onCellChange(row, col, $event)
                " />

              <ng-container
                *ngIf="
                  viewState === viewStates.GRADED &&
                  hasCorrectAnswers &&
                  showAnswers
                ">
                <i
                  *ngIf="showIncorrectForCell(row, col)"
                  class="bi bi-x color-danger fs-18 bold-icon grid-cell-status-icon"
                  title="Your answer - Incorrect"></i>

                <i
                  *ngIf="showCorrectForCell(row, col)"
                  class="bi bi-check color-success fs-18 bold-icon grid-cell-status-icon"
                  title="Your answer - Correct"></i>
              </ng-container>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
